<template>
	<div>
		<van-nav-bar @click-left="onClickLeft" title="修改昵称" left-arrow>
			<template #left>
				<van-icon name="../../../static/images/mobile/back.png" size="18" />
			</template>
		</van-nav-bar>
		<van-form validate-first @submit="onSubmit">
			<!-- 通过 pattern 进行正则校验 -->
			<van-field
				maxlength="16"
				v-model="nickName"
				name="pattern"
				placeholder="请输入16位字符以内，字母、数字、汉字任意组合"
				:rules="[{ pattern, message: '请输入正确昵称' }]"
				@input="changColor"
			/>
			<div :class="phoneNum > 0 ? 'onLoginbtn' : ' mobileLoginBtn_he'">
				<span @click="onSubmit()"><a href="javascript:;">提交</a></span>
			</div>
		</van-form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			nickName: "",
			pattern: /^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/,
			phoneNum: "",
		};
	},
	methods: {
		changColor(e) {
			this.phoneNum = e.length;
		},
		onClickLeft() {
			this.$router.go(-1);
		},
		onSubmit() {
			let params = {};
			params.nickName = this.nickName;
			this.$axiosPackag.getMessageByAxios("post", "/user/personsetdo", null, params, null, (resD) => {
				this.$router.push({ path: "/mobilePersonalMessage" });
			});
		},
	},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// MobilePersonalNickname.vue?26e07624